import { gql } from '@apollo/client';

export const GET_CARD = gql`
  query GetCard($where: CardUniqueFilterInput!) {
    card(where: $where) {
      id
      title
      secondaryTitle
      description
      url
      label
      brandKey
      status
      media
      body
      categories(first: 100) {
        order
        category {
          id
          level
          title
        }
      }
      tags(first: 100) {
        order
        tag {
          id
          title
          type
        }
      }
    }
  }
`;

export const GET_CARDS = gql`
  query GetCards(
    $first: UnsignedInt!
    $where: CardFilterInput
    $orderBy: [CardOrderingInput!]
  ) {
    cards(first: $first, where: $where, orderBy: $orderBy) {
      id
      title
      secondaryTitle
      description
      url
      label
      brandKey
      status
      media
      body
      categories(first: 100) {
        order
        category {
          id
          level
          title
        }
      }
      tags(first: 100) {
        order
        tag {
          id
          title
          type
        }
      }
    }
  }
`;
